import { Controller } from '@hotwired/stimulus';

// Fenêtre de prise de vue (<dialog>) : la photo prise remplit
// le champ fichier reçu à l'ouverture, comme un fichier choisi (`change`).
// Caméra coupée à la fermeture, y compris quand elle répond après (fenêtre
// fermée, rouverte ou page quittée entre-temps).
export default class extends Controller {
    static targets = ['video', 'error'];

    connect() {
        this.closeNow = () => this.cancel();
        document.addEventListener('turbo:before-cache', this.closeNow);
        window.addEventListener('pagehide', this.closeNow);
    }

    disconnect() {
        document.removeEventListener('turbo:before-cache', this.closeNow);
        window.removeEventListener('pagehide', this.closeNow);
        this.stop();
    }

    async open(input) {
        this.input = input;
        const opening = Symbol('opening');
        this.opening = opening;
        this.errorTarget.hidden = true;
        if (!this.element.open) this.element.showModal();
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment', width: { ideal: 1920 } }, audio: false });
            if (this.opening !== opening) {
                stream.getTracks().forEach((track) => track.stop());
                return;
            }
            this.stream = stream;
            this.videoTarget.srcObject = stream;
        } catch (error) {
            if (this.opening === opening) this.errorTarget.hidden = false;
        }
    }

    shoot() {
        const video = this.videoTarget;
        if (!this.stream || !video.videoWidth) return;
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0);
        canvas.toBlob((blob) => {
            const transfer = new DataTransfer();
            transfer.items.add(new File([blob], `photo-${Date.now()}.jpg`, { type: 'image/jpeg' }));
            this.input.files = transfer.files;
            this.input.dispatchEvent(new Event('change', { bubbles: true }));
            this.cancel();
        }, 'image/jpeg', 0.9);
    }

    cancel() {
        if (this.element.open) this.element.close();
        else this.stop();
    }

    stop() {
        this.opening = null;
        this.stream?.getTracks().forEach((track) => track.stop());
        this.stream = null;
        this.videoTarget.srcObject = null;
    }
}
